import React from 'react'
import FieldManagementLeftPanel from "./panel/form-left-panel"
import FieldManagementRightPanel from "./panel/form-right-panel"
import ErrorBoundary from "../../../../error-boundary"
import {FieldManagementFormProps} from "../../../render/management-form"
import FormManager from "../../../../gd-form/common/form-manager"

// const debug = "FieldManagementFormProto"
const debug = false

export default class FieldManagementFormProto extends React.Component<FieldManagementFormProps, any> {

    public form?            : FormManager
    public initFormData     : any
    public formStructure    : any

    private debounceOnUserChange: any

    static defaultProps = {
        isNew: false
    }

    constructor(props:FieldManagementFormProps) {
        super(props)

        this.initFormData = {
            label           : _.get(this.props, 'field.label', ''),
            description     : _.get(this.props, 'field.description', ''),
            fieldAccess     : _.get(this.props, 'field.fieldAccess', gd.const.customFields.access.EVERYONE),
            isRequired      : _.get(this.props, 'field.isRequired', false),
            treatAs         : _.get(this.props, 'treatAs', undefined),
        }

        this.formStructure = {
            fields: {
                label       : {
                    type        : 'input',
                    isRequired  : true,
                    label       : 'Label',
                    validator   : (val:any) => {
                        let res:any = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'Invalid label';
                        }
                        return res;
                    },
                    onUserChange: this.onUserChange,
                },
                description : {
                    type        : 'input',
                    isRequired  : false,
                    label       : 'Description',
                    onUserChange: this.onUserChange,
                },
                fieldAccess : {
                    type        : 'select',
                    isRequired  : true,
                    label       : 'Access',
                    onUserChange: this.onUserChange,
                },
                isRequired  : {
                    type        : 'boolean',
                    isRequired  : false,
                    label       : 'Is required',
                    onUserChange: this.onUserChange,
                },
                treatAs     : {
                    type        : 'select',
                    isRequired  : false,
                    label       : 'Use as',
                    onUserChange: this.onUserChange,
                },
            },
            // onSubmit: this.onSubmit
        };

        // this.form = new FormManager(formStructure, initFormData); that should happen in field!
    }

    componentDidMount() {
        this.debounceOnUserChange = _.debounce(this.submitOnChange, 500)
    }

    componentWillUnmount() {
        this.debounceOnUserChange?.flush()
    }

    submitOnChange = (result:any) => {
        debug && console.log(debug, 'submitOnChange', result)
        this.onSubmit(result)
    }

    onUserChange = (value:any) => {
        const result = this.form?.getValues()
        debug && console.log(debug, 'onUserChange', value, result)

        if (this.props.autoSaveChanges) {
            this.debounceOnUserChange(result)
        }
    }

    onSubmit(result:any) {
        debug && console.log(debug, 'onSubmit', result)

        this.props.field.label          = result.label.trim()
        this.props.field.description    = result.description.trim()
        this.props.field.isRequired     = !!result.isRequired
        this.props.field.fieldAccess    = result.fieldAccess

        debug && console.log(debug, 'onSubmit field', this.props.field)
    }

    renderAdditionalControls():any {
        return false
    }

    render() {
        return (
            <React.Fragment>
                <ErrorBoundary>
                    <FieldManagementLeftPanel field={this.props.field} />
                </ErrorBoundary>

                <ErrorBoundary>
                    <FieldManagementRightPanel parent           = {this}
                                               field            = {this.props.field}
                                               isNew            = {this.props.isNewField}
                                               disableRequired  = {this.props.disableRequired}
                                               autoSaveChanges  = {this.props.autoSaveChanges}
                                               showTreatAs      = {this.props.showTreatAs}
                                               entity           = {this.props.entity}>
                        {this.renderAdditionalControls()}
                    </FieldManagementRightPanel>
                </ErrorBoundary>
            </React.Fragment>
        )
    }
}